import apiClient from "./ApiService";
/**
 * @param {string} idTransaction
 * @param {string} stepField  : 'commerceData', 'files', 'cost', 'cicac'
 */
export async function updateManagerPageStep(idTransaction, stepField) {
  try {
    //Obtener ManagerPage completo
    const getResponse = await apiClient.get(
      `/adelselfservice/selfservice/manager-pages/id-Transaction/${idTransaction}`
    );

    // Imitar la validación de response.ok
    if (!getResponse || getResponse.status < 200 || getResponse.status >= 300) {
      console.error("No se pudo obtener el ManagerPage");
      return false;
    }

    const getJson = getResponse;
    const managerPage = getJson;

    //Validar que el campo exista
    if (!(stepField in managerPage)) {
      console.error(`El campo '${stepField}' no existe en ManagerPage`);
      return false;
    }

    //Marcar el paso como completado
    managerPage[stepField] = true;

    //Enviar actualización completa
    const updateResponse = await apiClient.put(
      `/adelselfservice/selfservice/manager-pages/transaction/${managerPage.idTransaction}`,
      managerPage
    );

    if (!updateResponse || updateResponse.status < 200 || updateResponse.status >= 300) {
      console.error("Error actualizando ManagerPage");
      return false;
    }

    return true;
  } catch (error) {
    console.error("Error en updateManagerPageStep:", error);
    return false;
  }
}